import axios from "axios";

export const SESSION_REQUEST = "SESSION_REQUEST";
export const SESSION_SUCCESS = "SESSION_SUCCESS";
export const SESSION_FAIL = "SESSION_FAIL";

export const SESSION_CLOSE_REQUEST = "SESSION_CLOSE_REQUEST";
export const SESSION_CLOSE_SUCCESS = "SESSION_CLOSE_SUCCESS";
export const SESSION_CLOSE_FAIL = "SESSION_CLOSE_FAIL";


// =============================================
// CSRF HELPER
// =============================================

const getCsrfToken = async () => {
  const response = await axios.get(
    "/api/kitchen/csrf/",
    {
      withCredentials: true,
    }
  );

  const token = response.data?.csrfToken;

  if (!token) {
    throw new Error(
      "Unable to obtain CSRF token from server."
    );
  }

  return token;
};


// =============================================
// CREATE DINING SESSION
// =============================================

export const createDiningSession =
  (restaurantId, tableId) =>
  async (dispatch) => {
    try {
      dispatch({
        type: SESSION_REQUEST,
      });

      const csrfToken = await getCsrfToken();

      const response = await axios.post(
        `/api/restaurants/${restaurantId}/tables/${tableId}/session/`,
        {},
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );

      dispatch({
        type: SESSION_SUCCESS,
        payload: response.data,
      });

      return response.data;

    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        "Failed to create dining session";

      dispatch({
        type: SESSION_FAIL,
        payload: message,
      });

      throw error;
    }
  };


// =============================================
// CLOSE DINING SESSION
// =============================================

export const closeDiningSession =
  (restaurantId, tableId, sessionToken) =>
  async (dispatch) => {
    try {
      dispatch({
        type: SESSION_CLOSE_REQUEST,
      });

      const csrfToken = await getCsrfToken();

      const response = await axios.post(
        `/api/restaurants/${restaurantId}/tables/${tableId}/session/close/`,
        {
          session_token: sessionToken,
        },
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );

      dispatch({
        type: SESSION_CLOSE_SUCCESS,
        payload: response.data,
      });

      return response.data;

    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        "Failed to close dining session";

      dispatch({
        type: SESSION_CLOSE_FAIL,
        payload: message,
      });

      throw error;
    }
  };